import React, { useState, useEffect, useRef } from "react";
import { AppSettingContext } from "@src/components/Application";
import RecipientDetails from "../RecipientDetails";
import RecipientsStepWhenToSend from "./RecipientsStepWhenToSend";
import LabeledCheckbox from "../../atoms/LabeledCheckbox";
import { IRecipientDetails } from "../../../models/RecipientDetails.model";
import { GiftCardSendTypeEnum } from "../../../models/enums/GiftCardSendTypeEnum";
import IScheduleSendDetails from "../../../models/interfaces/ScheduleSendDetails.interface";

interface IRecipientsStepRecipientsDetailsProps {
    recipients: IRecipientDetails[];
    sendIndividually: boolean;
    sendBy: GiftCardSendTypeEnum;
    sendItLater: boolean;
    scheduleSendDetails: IScheduleSendDetails;

    handleSendIndividualyChange(sendIndividualy: boolean): void;
    handleChangeSendItLater(sendItLater: boolean): void;
    handleRecipientUpdate(model: IRecipientDetails, index: number): void;
    handleSendItLaterUpdate(model: IScheduleSendDetails): void;
}

const RecipientsStepRecipientsDetails = (props: IRecipientsStepRecipientsDetailsProps) => {

    //Page translation
    const { labels } = React.useContext(AppSettingContext);

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Init
    useEffect(() => {
        //local model initialization
        setIsLoading(true);
    }, []);

    //useEffect(() => {
    //    if (props.recipients.length === 1) {
    //        props.handleSendIndividualyChange(false);
    //    } else if (props.recipients.length > 1) {
    //        if (props.sendIndividually == false) {
    //            props.handleSendIndividualyChange(true);
    //        }
    //    }
    //}, [props.recipients])

    const getRecipients = (): IRecipientDetails[] => {

        const recipients = [] as IRecipientDetails[];
        if (props.recipients.length == 0) return recipients

        if (props.sendIndividually == false) {
            //then show only the first recipient
            if (props.recipients.length) {
                recipients.push(props.recipients[0]);
            }

        } else {
            //show all
            return props.recipients;
        }

        return recipients;
    }
    const recipients = getRecipients();

    if (error) throw error;
    return (
        <>
            <div className="recipient-details fadeIn">
                <h5>{labels.get("GiftCard.App.Steps.Recepients.RecipientDetails.Title")}</h5>

                {/*show only of there are more than 1 recipients*/}
                {(props.recipients && props.recipients.length > 1) &&
                    <>
                        <div className="form-field">
                            <LabeledCheckbox id="recipients__send-individually" cssClass=""
                                checked={props.sendIndividually}
                                onChange={(checked: boolean) => props.handleSendIndividualyChange(checked)}
                                labelCssClass="label-fs"
                                lableTitle={labels.get("GiftCard.App.Steps.Recepients.Fields.SendIndividually")}
                            />
                        </div>
                    </>}
            </div>

            {(props.recipients && props.recipients.length > 0) &&
                <div className="recipients-box">
                    {recipients.map((recipient, index) => (
                        <RecipientDetails
                            key={index + 1}
                            index={index + 1}
                            model={recipient}
                            sendBy={props.sendBy}
                            handleModelUpdate={(model) => props.handleRecipientUpdate(model, index)} />
                    ))}

                    {props.sendBy !== GiftCardSendTypeEnum.BY_PDF &&
                        <RecipientsStepWhenToSend
                            sendItLater={props.sendItLater}
                            model={props.scheduleSendDetails}
                            handleChangeSendItLater={(sendItLater: boolean) => props.handleChangeSendItLater(sendItLater)}
                            handleModelUpdate={(model) => props.handleSendItLaterUpdate(model)} />
                    }
                </div>}

        </>
    )
}

export default RecipientsStepRecipientsDetails;